import { DOCUMENT } from '@angular/common';
import {
    Component,
    ElementRef,
    Inject,
    Input,
    OnInit,
    ViewChild,
} from '@angular/core';

@Component({
    selector: 'app-video',
    templateUrl: './video.component.html',
    styleUrls: ['./video.component.scss'],
})
export class VideoComponent implements OnInit {
    videoPlaying: boolean = false;
    backgroundImageSource: string = 'assets/images/homepage_banner.jpg';

    @Input() pretitle = '';
    @Input() title = '';

    constructor() {}

    ngOnInit(): void {}

    playVideo() {
        this.videoPlaying = true;
        this.backgroundImageSource = '';
    }

    videoEnded() {
        this.backgroundImageSource = 'assets/images/homepage_banner.jpg';
        this.videoPlaying = false;
    }
}
